import { Injectable, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { HttpError } from 'app/errors';

@Injectable()
export class GradeService {
  private newGrade = new Subject<string>();
  public newGrade$ = this.newGrade.asObservable();
  private setGood = false;
  constructor(private http: HttpClient) { }

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  updateGrade(grade) {
    this.newGrade.next(grade);
  }

  updateGradeValue(examinationId, werkprocessId, value) {
    return this.http.post<string>(`/kerntaken/${examinationId}/werkproces/${werkprocessId}/resultaat?Resultaat=${value}`, {})
      .pipe(catchError(error => {
        throw new HttpError(`Probleem bij het versturen van de cijfer informatie`);
      }));
  }

  setAllGradesAsGood() {
    this.setGood = true;
    this.change.emit(this.setGood);
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/grade.service.ts